export const QUESTION_BANK_REVIEW = 'questionBankReview';
export const GET_QUESTION_BANK_REVIEW = `${QUESTION_BANK_REVIEW}/getQuestionBankReviewAction`;
export const GET_QUESTION_QBR = `${QUESTION_BANK_REVIEW}/getQuestionQBRAction`;
export const SET_QUESTION_REVIEW_BANK = `${QUESTION_BANK_REVIEW}/setQuestionReviewBankAction`;
export const SET_QUESTION_BANK = `${QUESTION_BANK_REVIEW}/setQuestionSuggestionAction`;
export const GET_CURRENT_AND_PREVIOUS = `${QUESTION_BANK_REVIEW}/GetCurrentAndPreviousQuestionAction`;
export const GET_QUESTION_DETAILS_PREVIEW = `${QUESTION_BANK_REVIEW}/GetQuestionDetailsForPreviewAction`;
export const SET_QUESTION_PREVIEW = `${QUESTION_BANK_REVIEW}/SaveQuestionReviewAction`;
export const GET_QUESTION_PREVIEW = `${QUESTION_BANK_REVIEW}/EditQuestionReviewAction`;

// export const DELETE_QUESTION_BANK = `${QUESTION_BANKS}/deleteQuestionBankAction`;


